import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ProfilePreviewContext from '../../../store/ProfilePreviewContext';
import ProfileOverview from '../ProfileOverview';

export default function ProfilePreviewProvider({ children }) {
  const [previewUserId, setPreviewUserId] = useState(null);

  const openProfilePreview = useCallback((userId) => {
    const normalizedUserId = typeof userId === 'string' ? userId.trim() : '';
    if (normalizedUserId) {
      setPreviewUserId(normalizedUserId);
    }
  }, []);

  const closeProfilePreview = useCallback(() => {
    setPreviewUserId(null);
  }, []);

  const value = useMemo(() => ({
    openProfilePreview,
  }), [openProfilePreview]);

  return (
    <ProfilePreviewContext.Provider value={value}>
      {children}
      {previewUserId ? (
        <ProfileOverview userId={previewUserId} onClose={closeProfilePreview} />
      ) : null}
    </ProfilePreviewContext.Provider>
  );
}

ProfilePreviewProvider.propTypes = {
  children: PropTypes.node,
};
